interface Props {
  title: string
}

const PageTitle = ({ title }: Props) => {
  return <h1 className='text-[28px] font-bold'>{title}</h1>
}

export default PageTitle
